import { useCallback } from "react";
import { useParams } from "react-router-dom";

const usePathWithSlug = () => {
  const { slug } = useParams();

  return useCallback((path: string) => `${slug ? `/x/${slug}` : ""}${path}`, [slug]);
};

export default usePathWithSlug;
